// postCreateCharacterFromImage.ts
import apiRequest from './apiRequest';

export interface CharacterFromImageResponse {
  message: string;
  jobID: string;
  characterRecord: string;
}

export async function postCreateCharacterFromImage(payload: {
  fileExtension: string;
  imageIndex: number;
  jobID: string;
  prompt: string;
  wsHttpEndpoint?: string;
  wsConnectionID?: string;
}): Promise<CharacterFromImageResponse> {
  const { data } = await apiRequest<CharacterFromImageResponse>(
    'mogen-orchestration',
    `/characters/fromImage`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
  return data!;
}
